import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/description.css';

import calendarIcon from '../../../assets/icons/calendar.svg';
import heartIcon from '../../../assets/icons/heart.svg';
import shareIcon from '../../../assets/icons/share.svg';
import activeHeartIcon from '../../../assets/icons/bottomBar/active_heart.svg';
import starIcon from '../../../assets/icons/star.svg';
import chatIcon from '../../../assets/icons/chat.svg';

import { addToFavorites, removeFromFavorites } from "../../../api/favoritecall";
import Icon from '../../../common/components/Icon';
import { t } from 'i18next';
import { formatPrice } from '../../../utils/formatPrice';
import { trackButtonClick } from '../../../utils/AnalyticsUtils';

const Description = ({
    id,
    title,
    date,
    price,
    price_type,
    is_negotiable,
    barter,
    description,
    phone,
    rating,
    reviews,
    user_id,
    is_favorite = false,
}) => {

    const navigate = useNavigate();
    const [isFavorite, setIsFavorite] = useState(is_favorite);
    const [showFormattedPhone, setShowFormattedPhone] = useState(false);

    useEffect(() => {
        setIsFavorite(is_favorite);
    }, [is_favorite]);

    const handleFavoriteToggle = async (e) => {
        e.stopPropagation();
        e.preventDefault();

        const accessToken = localStorage.getItem("access_token");

        if (!accessToken) {
            navigate('/sign');
            return;
        }

        try {
            if (isFavorite) {
                await removeFromFavorites(id);
                trackButtonClick('remove_favorite', { announcement_id: id });
                setIsFavorite(false);
            } else {
                await addToFavorites(id);
                trackButtonClick('add_favorite', { announcement_id: id });
                setIsFavorite(true);
            }
        } catch (error) {
            console.error("Error toggling favorite:", error);
            setIsFavorite(!isFavorite);
        }
    };

    const handlePhoneToggle = () => {
        setShowFormattedPhone(!showFormattedPhone);
    };

    const handleShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: title,
                    text: description,
                    url: window.location.href,
                });

                trackButtonClick('share_content', { announcement_id: id });

            } catch (error) {
                console.error('Error sharing content:', error);
            }
        } else {
            alert('Sharing is not supported in this browser.');
        }
    };

    const handleMessageClick = () => {
        navigate('/profile#messages', {
            state: {
                user_id,
                announcement_link: `https://agroland.kz/announcement/${id}`,
                announcement_id: id
            }
        });

        trackButtonClick('send_message', { announcement_id: id });
    };

    const formattedDate = new Date(date).toLocaleDateString(t('locale'));

    const formattedPhone = phone
        ? phone.replace(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5')
        : 'Номер не указан';

    return (

        <div className="description_content">

            {/* HEADER */}
            <div className="description_header">

                <div className="announcement_date_content">
                    <img src={calendarIcon} alt="Calendar Icon" />

                    <p className="announcement_date">
                        {t('publishedAt')} {formattedDate}
                    </p>
                </div>

                <div className="action_icons">

                    <img
                        src={shareIcon}
                        alt="share"
                        className="favorite_icon click"
                        onClick={handleShare}
                    />

                    <img
                        key={isFavorite ? "favorite" : "not-favorite"}
                        src={isFavorite ? activeHeartIcon : heartIcon}
                        alt={isFavorite ? "Remove from favorites" : "Add to favorites"}
                        className="favorite_icon click"
                        onClick={handleFavoriteToggle}
                    />

                </div>

            </div>

            {/* TITLE */}
            <h2 className="announcement_title">
                {title || 'Без названия'}
            </h2>

            {/* PRICE */}
            <div className="announcement_price">
                <span>{formatPrice(price, price_type, is_negotiable, barter)}</span>
            </div>

            {/* PHONE BUTTON */}
            <div className="announcement_user_number">
                <p>{showFormattedPhone ? formattedPhone : '+7 7'}</p>
                <button className="announcement_user_number_button click" onClick={handlePhoneToggle}>
                    {t('show_phone')}
                    <Icon src={"phone"} whiteicon={"white_icon"} />
                </button>
            </div>

            {/* RATING */}
            <div className="announcement_rating">

                <div className="rating_number">
                    <img src={starIcon} alt="Star Icon" />

                    <p>
                        {t('rating')} {String(rating || '5').slice(0, 3)}
                    </p>
                </div>

                <div className="announcement_reviews">
                    <p>
                        <span>{t('feedbacks')}:</span>

                        <span className="announcement_reviews_count">
                            {reviews || 0}
                        </span>
                    </p>
                </div>

            </div>

            {/* MESSAGE BUTTON */}
            <div className="announcement_message click" onClick={handleMessageClick}>
                <p>{t('message')}</p>
                <img src={chatIcon} alt="Chat Icon" className="arrow" />
            </div>

        </div>
    );
};

export default Description;